export const getProviders = (state, providers) => {
  state.providers = providers
}

export const setLoading = (state, value) => {
  state.loading = value;
}
